
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonList, IonItem } from "@ionic/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Home",
  components: {
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonList,
    IonItem,
  },
});
